import { render, staticRenderFns } from "./CandidateCoursesHistory.vue?vue&type=template&id=0d620454&scoped=true&lang=pug"
import script from "./CandidateCoursesHistory.vue?vue&type=script&lang=js"
export * from "./CandidateCoursesHistory.vue?vue&type=script&lang=js"
import style0 from "./CandidateCoursesHistory.vue?vue&type=style&index=0&id=0d620454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d620454",
  null
  
)

export default component.exports